<template>
    <ul class="totalHour">
        <li class="totalHour_today" >
            <label class="font-weight-bold">Hôm nay :</label>
            <span>{{ (_.get(statistics, 'totalHoursOfDay', 0)/8).toFixed(2) }} Ngày</span>
        </li>
        <li class="totalHour_week">
            <label class="font-weight-bold">Tuần này :</label>
            <span>{{ (Math.round((_.get(statistics, 'totalHoursOfWeek', '') / 8) * 100) / 100).toFixed(2) }} Ngày</span>
        </li>
        <li class="totalHour_month">
            <label class="font-weight-bold">Tháng này :</label>
            <span>{{(_.get(statistics, 'totalHoursOfMonth', 0)/8).toFixed(2) }} Ngày</span>
        </li>
    </ul>
</template>
<script>
    import RepositoryFactory from '@/repositories/RepositoryFactory'
    const ScheduleRepository = RepositoryFactory.get('schedule')
    export default {
        data () {
            return {
                statistics: {}
            }
        },
        created () {
            this.statisticHour()
        },
        methods: {
            async statisticHour () {
                const response = await ScheduleRepository.statistic()
                if (_.get(response, 'success', false)) {
                    this.statistics = _.get(response, 'data', {})
                }
            },
        }
    }
</script>